import React from 'react';
import Header from '../../components/Header/header';
import SmtpConfigForm from '../../Forms/SmtpConfigForm';
import { useNavigate } from 'react-router-dom';

const SmtpConfig: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <SmtpConfigForm Back={() => navigate(-1)} />
    </>
  );
};

export default SmtpConfig;
